export async function retry<T>(
  fn: () => Promise<T>,
  retries = 2,
  delayMs = 500,
): Promise<T> {
  let attempt = 0;
  while (attempt <= retries) {
    try {
      return await fn();
    } catch (error) {
      attempt++;

      if (import.meta.env.DEV && attempt > 0) {
        console.warn(`Retry attempt ${attempt} failed:`, error);
      }

      if (attempt > retries) {
        throw error;
      }
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
  throw new Error('Unexpected error in retry logic');
}
